module.exports = __webpack_public_path__ + "img/Brown_Mixed.3e53edb6.png";